import { TAccountDiscountInfoType } from '@boss/services/client';

type DiscountInfo = {
  [key: string]: {
    code: TAccountDiscountInfoType;
    rgb: string;
  };
};

export const DISCOUNT_TYPES: DiscountInfo = {
  DEFAULT: {
    code: '1',
    rgb: '#226E55',
  },
  SPECIFIC: {
    code: '2',
    rgb: '#B74433',
  },
  WORKSITE: {
    code: '3',
    rgb: '#7FACC6',
  },
};

/**
 * Discount group used for anonymous customers on /discountinfos type=4
 * calls (ticket 45173). The value is app-setting-configured per the
 * ticket; overridable at deploy time via NEXT_PUBLIC_ANONYMOUS_DISCOUNT_GROUP_ID.
 */
export const ANONYMOUS_DISCOUNT_GROUP_ID = process.env.NEXT_PUBLIC_ANONYMOUS_DISCOUNT_GROUP_ID ?? 'S-VAKMAN';
